// 자동 생성된 번역 테이블 (NAV → PAGES → MODAL → BOARD)
export const table = {
  "강" : " ",
  "분" : "minute",
  "총" : "Total",
  "건" : " ",
  "개" : " ",

  // ---------- NAV ----------
  "마이페이지": "My Page",
  "나의 수강강좌": "My Courses",
  "나의 문의": "My Inquiries",
  "강좌관리": "Course Management",
  "강좌Q&A관리": "Q&A Management",
  "관심콘텐츠": "Favorite",
  "내가본콘텐츠": "My History",
  "내정보관리": "My Profile",
  "사업소개": "Overview",
  "OpenVLab 이란?": "About OpenVLab",
  "플랫폼 안내": "Introduction",
  "사업홍보": "PR",
  "강좌·콘텐츠": "Courses & Content",
  "VLab 강좌": "VLab Courses",
  "XR콘텐츠": "XR Content",
  "알림공간": "Support",
  "공지사항": "Notices",
  "이용문의 및 제안": "Contact",
  "가상실험실습체험관": "Vitual Lab",
  "회원가입": "Sign Up",
  "로그인": "Login",
  "로그아웃" : "Logout",
  "아이디 찾기": "Find ID",
  "비밀번호 찾기": "Find Password",
  "비밀번호 재설정": "Reset Password",
  "휴면계정안내": "Inactive Account",
  "이용약관": "Terms of Use",
  "개인정보처리방침": "Privacy Policy",
  "저작권보호정책": "Copyright",
  "검색결과": "Search Results",
  "관리시스템 바로가기" : "Go to Admin Console",

  // ---------- HEADER ----------
  "무엇을 도와드릴까요?" : "How can we help you?",

  // ---------- FOOTER ----------
  "(03087) 서울특별시 종로구 대학로 86(동숭동), 오픈브이랩": "OpenVLab, Daehak-ro, Jongno-gu, Seoul, Republic of Korea, 03087",
  "문의 및 제안" : "Inquiries & Suggestions",
  "패밀리사이트" : "Family Site",
  "한국방송통신대학교" : "Korea National Open University",
  "교육부" : "Ministry of Education",

  // ---------- CHIP ----------
  "기관" : "Organization",
  "실습형XR" : "Experiential XR",
  "체험형XR" : "Practical XR",
  "초급" : "Beginner",
  "중급" : "Intermediate",
  "고급" : "Advanced",
  "교육중": "In Progress",
  "미수료": "Incomplete",
  "수료": "Completed",
  "취소대기": "Cancellation Pending",
  "미승인": "Not Approved",
  "수강신청": "Apply",
  "수강접수": "Registered",
  "수강신청반려": "Rejected",
  "수강결제완료": "Payment Complete",
  "수강승인": "Approved",
  "수강취소": "Cancel",
  "수강미달": "Insufficient",
  "수강완료": "Completed",
  "강의중": "Ongoing",
  "대기중": "Waiting",
  "종강": "Ended",
  "승인": "Approved",
  "승인대기": "Pending",
  "중요" : "Important",

  // ---------- BUTTON ----------
  "취소": "Cancel",
  "확인" : "Confirm",
  "목록" : "List",
  "초기화" : "Reset",
  "기관검색" : "Search",
  "승인요청" : "Request",
  "검색" : "Search",
  "홈" : "Home",
  "회원탈퇴" : "Delete Account",
  "등록": "Submit",
  "다운로드": "Download",
  "기간만료": "Expired",
  "강의보기" : "View",
  "다음" : "Next",
  "인증코드 발송" : "Send Verification Code",
  "인증코드 재발송" : "Resend Verification Code",
  "인증코드 확인중..." : "Verifying Code...",
  "다시 찾기" : "Try Again",
  "계정잠금해제" : "Unlock Account",
  "문의하기" : "Contact",
  "미리보기" : "Preview",
  "상세보기" : "Detail",
  "체험하기" : "Enroll",
  "파일선택" : "Select File",

    // ---------- Modal ----------
  "알림" : "Alert",
  "안내" : "Information",
  "로그인 후 이용 가능합니다." : "Login is required.",

  // ---------- Filed / Board / Mypage ----------
  "아이디" : "ID",
  "비밀번호" : "Password",
  "전체" : "All",
  "강좌선택" : "Select Course",
  "검색어를 입력해 주세요" : "Enter keywords",
  "비밀번호를 입력해 주세요" : "Enter password",
  "번호" : "NO",
  "강좌" : "Course",
  "강의" : "Lecture",
  "섹션" : "Section",
  "강좌명" : "Course Title",
  "수강기간" : "Duration",
  "수강자" : "Student",
  "진도율" : "Progress",
  "회차" : "Session",
  "수료증" : "Certificate",
  "비고" : "Remarks",
  "14세이상": "14+",
  "14세미만": "<14",
  "외국인": "Foreigner",
  "학생": "Student",
  "조교": "Assistant",
  "교수": "Professor",
  "교수자": "Professor",
  "남자": "Male",
  "여자": "Female",
  "내국인": "Korean",
  "일반": "General",
  "고등교육기관": "Higher Education",
  "일반학습자": "General Student",
  "기관학습자": "Organization Student",
  "분류" : "Category",
  "제목" : "Title",
  "답변유무" : "Status",
  "등록일" : "Date",
  "대기" : "Pending",
  "완료" : "Done",
  "조회수" : "Views",
  "소중한 개인정보관리를 위해 사용 중인 비밀번호를 한 번 더 입력해 주세요." : "For security verification, please re-enter your password.",
  "강의목록" : "List",
  "소개" : "Overview",
  "과정소개" : "Course Overview",
  "과정특징" : "Course Features",
  "학습대상" : "Target Learners",
  "강사소개" : "Instructor Introduction",
  "설문" : "Survey",
  "첨부파일" : "Attachment",
  "공지" : "Notice",
  "강좌문의" : "Course Inquiry",
  "공통문의" : "General Inquiry",
  "기본정보" : "Profile",
  "가입일" : "Join Date",
  "소셜 계정" : "Connected Account",
  "이메일 계정" : "Email",
  "이름" : "Name",
  "휴대전화번호" : "Phone",
  "기관정보" : "Organization Info",
  "기관명" : "Organization Name",
  "기관상세정보" : "User Type",
  "비밀번호 변경" : "Reset Password",
  "승인불가" : "Request Denied",
  "되었습니다." : " ",
  "승인대기중" : "Pending Approval",
  "입니다." : " ",
  "기관정보 등록은 해당 기관의 관리자 승인 이후 가능합니다." : "To register organization information, approval from the organization’s administrator is required.",
  "기관검색을 통해 입력해 주세요" : "Search and select your organization",
  "기관상세정보를 선택 해 주세요" : "Select user type",
  "현재 비밀번호": "Current Password",
  "현재 비밀번호를 입력해 주세요": "Enter Current Password",
  "새 비밀번호": "New Password",
  "새로 사용하실 비밀번호를 입력해 주세요": "Enter New Password",
  "영문, 숫자, 특수문자를 조합해 10자 이상 입력( ! @ # $ % ^ & + = 가능)": "Use 10+ characters with letters, numbers, and symbols (! @ # $ % ^ & + = allowed)",
  "새 비밀번호 확인": "Confirm New Password",
  "새로 사용하실 비밀번호 다시 입력": "Re-enter New Password",
  "기관 선택": "Select Organization",
  "선택": "Select",
  "유형": "Type",
  "기관코드": "Organization Code",
  "하위기관명": "Sub Organization",
  "대분류 전체": "Main Category",
  "중분류 전체": "Subcategory",
  "대카테고리" : "Main Category",
  "중카테고리" : "Subcategory",
  "소카테고리" : "Deatil Category",
  "기관명을 입력해 주세요": "Enter Organization Name",
  "데이터가 없습니다." : "No Data",
  "회원 탈퇴 시, 이메일 계정 재사용 및 복구가 불가합니다.": "Once your account is deleted, the email address cannot be reused or restored.",
  "회원 탈퇴를 신청하시면 현재 접속 중인 이메일 계정은 즉시 탈퇴 처리됩니다." : "Once you submit an account deletion request, your currently signed-in email address will be removed immediately.",
  "삭제되는 항목은 다음과 같습니다.": "The following information will also be permanently deleted.",
  "회원정보: 아이디/비밀번호/생년월일/이메일/성별/지역 등 모든 개인정보": "Personal Information: User ID / Password / Date of Birth / Email Address / Gender / Region and other personal data",
  "강좌 및 콘텐츠 선호도 정보": "Course & Content Preferences",
  "내가 남긴 게시글": "My Posts",
  "기타: 접속 IP, 접속기록 등 접속로그 데이터": "Other: Access logs (IP address, login history)",
  "회원정보": "Account Information",
  "계정 연동 기관": "Linked Organization",
  "기관 없음": "No Organization",
  "탈퇴사유": "Reason for Leaving",
  "탈퇴 사유를 입력해 주세요": "Enter reason for leaving",
  "안내 사항을 모두 확인했으며, 탈퇴 시 이메일 계정 재사용 및 데이터 복구가 불가능한 점에 동의합니다.": "I have read all the information and agree that my email account cannot be reused or restored after withdrawal.",
  "기관 학습자의 회원 탈퇴는 소속 기관 관리자의 확인 후 완료됩니다.": "For organization learners, withdrawal will be completed after the organization administrator approves the request.",
  "관심콘텐츠 목록에서 삭제되었습니다.": "Removed from your favorites.",
  "나의 관심콘텐츠가 없습니다.": "You have no favorite content.",
  "해당 관심콘텐츠를 삭제하시겠습니까?": "Do you want to delete this favorite content?",
  "내가본콘텐츠가 없습니다.": "You have no My History's Content.",
  "내가본콘텐츠 삭제": "Delete My History's Content",
  "해당 콘텐츠를 삭제하시겠습니까?": "Do you want to delete this content?",
  "강좌요약" : "Summary",
  "강좌개요" : "Overview",
  "현재 수강생" : "Enrolled Students",
  "평균 진도율" : "Average Progress",
  "설문 참여율" : "Survey Participation",
  "수료 완료" : "Completed",
  "수강생 목록" : "Students List",
  "학과" : "Department",
  "진행상태" : "Status",
  "설문진행" : "Survey",
  "등록자" : "Author",
  "강의 목록" : "Lecture List",
  "등록된 Q&A 내역이 없습니다.": "No Q&A records available.",
  "답변 대기중입니다.": "Awaiting reply.",

  // ---------- SIGN UP / LOGIN ----------
  "카카오": "Kakao",
  "네이버": "Naver",
  "구글": "Google",
  "가입하기" : "Sign Up",
  "간편회원가입" : "Social Sign Up",
  "OpenVLab에 오신 것을 환영합니다." : "Welcome to OpenVLab!",
  "일반학습자 또는 기관학습자 중 본인에게 해당하는 유형을 선택해 주세요." : "Please choose between General Student and Organization Student.",
  "가입하신 아이디(이메일 주소)를 입력해 주세요. 해당 이메일로 임시 비밀번호를 발송해 드립니다." : "Enter your registered ID (email). We will send a temporary password to registered email.",
  "기관(학교) 정보 등록이 필요한 경우, [기관학습자]로 가입해 주세요." : "To register organization (school) information, sign up as an [organization student].",
  "회원유형선택" : "Membership Type",
  "회원 유형에 따라 가입 절차가 다릅니다. 본인에게 해당하는 유형을 선택해 주세요." : "The registration process may vary depending on the membership type. Please select the appropriate type.",
  "만 14세 미만 회원" : "Users Under 14",
  "만 14세 이상 회원" : "Users Aged 14+",
  "만 14세 이상" : "Users Aged 14+",
  "외국인 회원" : "Foreigner",
  "(국내거주)" : "Resident in Korea",
  "약관동의" : "Terms Agreement",
  "실명 인증된 계정(이메일 주소)으로 가입하며, 필수 동의 사항 외에 개인정보 수집·처리 방침(선택)을 포함합니다." : "To use OpenVLab’s services, we request your agreement to the Terms of Use and the Personal Information Collection and Usage Policy. Please review the details carefully and decide whether to provide your consent.",
  "개인정보 수집 및 이용 안내" : "Personal Information Collection",
  "제3자 정보제공 동의" : "Consent to Third-Party Information Provision",
  "[필수]" : "[Required]",
  "필수 약관에 동의해 주세요." : "Please agree to the required terms.",
  "본인인증" : "Identity Verification",
  "법정대리인 본인인증" : "Legal Guardian Identity Verification",
  "OpenVLab은 개인정보에 대한 유출 및 도용을 방지하기 위해 본인인증을 시행하고 있습니다." : "To protect your personal data, OpenVLab requires identity verification.",
  "만 14세 미만 아동의 개인정보 수집 시 보호자(법정대리인)의 동의를 얻도록 규정하고 있습니다." : "In accordance with relevant regulations, the consent of a parent or legal guardian is required when collecting personal information from children under the age of 14.",
  "\"부모님(법적보호자)의 동의\"는" : "\"Parental (legal guardian) consent\" is deemed to be granted once the",
  "부모님(법적보호자)의 본인인증으로 동의" : " parent or legal guardian completes the identity verification process.",
  "한 것으로 간주됩니다." : " ",
  "만 14세 미만 회원 정보 입력" : "Under 14 Member Information",
  "만 14세 미만은 개인정보 수집 시 보호자의 동의가 필요합니다. 법정대리인의 본인 인증을 통해 가입을 진행해 주세요." : "Users under the age of 14 must obtain a guardian’s consent for the collection of personal information. Please proceed with registration by completing the legal guardian’s identity verification.",
  "「정보통신망 이용촉진 및 정보보호 등에 관한 법률 제23조 2항(주민번호 사용 제한)」에 의거" : "In accordance with 「Article 23-2 of the Act on Promotion of Information and Communications Network Utilization and Information Protection」 ",
  "하여, 웹사이트 내 주민등록번호 수집·이용이 금지되어 주민번호 입력 기반의 인증 서비스 사용이 제한됩니다." : "the collection and use of resident registration numbers on websites is prohibited. Therefore, authentication services that rely on inputting resident registration numbers are restricted.",
  "법정대리인 휴대전화 인증" : "Legal Guardian Mobile Verification",
  "보호자 명의의 휴대전화로 인증을 진행해 주세요." : "Please complete guardian verification via phone number.",
  "휴대전화 번호로 본인 인증" : "Verify Your Identity via Phone Number",
  "본인 명의의 휴대전화로 인증을 할 수 없는 경우 회원가입에 제한이 있습니다." : "Registration may be restricted if mobile verification cannot be completed.",
  "사용자가 본인인증을 취소하였습니다." : "The user has canceled the identity verification.",
  "회원정보입력" : "Member Information",
  "성별" : "Gender",
  "출생연도" : "Birth Year",
  "국적" : "Nationality",
  "비밀번호 확인" : "Confirm Password",
  "이름을 입력해 주세요" : "Enter your name",
  "이름을 입력해 주세요." : "Please enter your name.",
  "성별을 선택해 주세요" : "Select your gender",
  "성별을 선택해 주세요." : "Please select your gender.",
  "출생연도를 선택해 주세요" : "Select your birth year",
  "출생연도를 선택해 주세요." : "Please select your birth year.",
  "국적을 선택해 주세요" : "Select your nationality",
  "국적을 선택해 주세요." : "Please select your nationality.",
  "번호를 입력해 주세요" : "Enter your phone number",
  "번호를 입력해 주세요." : "Please enter your phone number.",
  "휴대전화번호를 입력해 주세요." : "Please enter your phone number.",
  "이메일 아이디를 입력해 주세요" : "Enter your email username",
  "이메일 주소를 입력해 주세요" : "Enter your email domain",
  "이메일 형식이 올바르지 않습니다." : "Please enter a valid email address.",
  "이메일 인증을 완료해 주세요." : "Please complete email verification.",
  "이메일 체크 중 오류가 발생했습니다." : "Email check failed.",
  "비밀번호 규정을 확인해 주세요." : "Please meet the password requirements.",
  "직접입력" : "Enter Manually",
  "인증코드를 입력해 주세요" : "Enter verification code",
  "입력하신 이메일로 발송된 인증코드를 입력해 주세요. 메일을 받지 못하신 경우, 스팸함을 확인해 주세요." : "Please enter the verification code sent to your email account. If you did not receive the email, please check your spam folder.",
  "대소문자구분 영문, 숫자, 특수문자를 조합하여 10자 이상 입력. (! @ # $ % ^ & + = 사용가능)" : "Use 10 or more characters combining uppercase, lowercase, numbers, and special characters (! @ # $ % ^ & + =)",
  "비밀번호를 한번 더 입력 해 주세요." : "Re-enter your Password",
  "기관정보 입력" : "Organization Info",
  "기관상세정보를 선택해 주세요" : "Select Organization Details",
  "CP, 기관 관계자 및 관련 회원 가입 시 인증을 위해 추가 서류를 요청을 할 수 있습니다." : "Additional documents may be required for verification for CPs and Organization members during registration.",
  "이미 등록된 사용자입니다." : "User already registered.",
  "아이디/비밀번호 찾기를 해 주세요." : "Please use the ID/Password finder.",
  "가입완료" : "Completed",
  "OpenVLab 가입을 환영합니다." : "Welcome to OpenVLab.",
  "지금 바로 OpenVLab의 다양한 XR콘텐츠 및 강좌를 체험해 보세요." : "Explore OpenVLab’s diverse XR content and courses.",
  "관리자 승인 후 기관학습자 가입이 완료됩니다." : " student registration will be completed after administrator approval.",
  "간편로그인" : "Social Login",
  "아이디(이메일 주소)" : "ID(Email Address)",
  "아이디 저장" : "Save ID",
  "오류가 발생했습니다." : "An error has occurred.",
  "개를 찾았습니다." : "items found.",
  "비밀번호를 잊으셨다면 [비밀번호 찾기]를 이용해 주세요." : "If you forgot your password, please use [Find Password].",
  "일치하는 회원 정보를 찾을 수 없습니다." : "No matching user information found.",
  "서비스 이용을 위해 [회원가입]을 진행해 주세요." : "Please [Sign up] to use the service.",
  "기관회원" : "Organization Student",
  "일반회원" : "General Student",
  "입력하신 아이디(이메일)로 임시 비밀번호를 발송했습니다.": "A temporary password has been sent to your email.",
  "로그인 후 [마이페이지]에서 비밀번호를 변경해 주세요.": "Please log in and update your password on [My Page].",
  "메일을 받지 못하신 경우, 스팸함을 확인해 주세요.": "If you did not receive the email, please check your spam folder.",
  "입력하신 정보에 일치하는 정보가 없습니다.": "No matching information was found for the data you entered.",
  "비밀번호가 재설정 되었습니다.": "Your password has been reset.",
  "새로운 비밀번호로 로그인 하실 수 있습니다.": "You can now log in with your new password.",
  "임시비밀번호를 입력해 주세요.": "Please enter a temporary password.",
  "비밀번호를 입력해 주세요.": "Please enter a password.",
  "새 비밀번호를 입력해 주세요.": "Please enter a new password.",
  "비밀번호가 일치하지 않습니다.": "Passwords do not match.",
  "임시비밀번호": "Temporary Password",
  "이메일 계정으로 받은 임시비밀번호를 입력해 주세요": "Enter the temporary password sent to your email.",
  "새로 사용하실 비밀번호를 다시 입력해 주세요": "Re-enter your new password",
  "이메일을 입력해 주세요." : "Please enter your email.",
  "일치하는 이메일 계정이 없습니다." : "No matching email account found.",
  "비밀번호는 최소 10자 이상이어야 합니다." : "Password must be at least 10 characters long.",
  "로그인을 연속 5회 틀리셨습니다.\n아이디/비밀번호 찾기 후 이용해 주세요." : "You have entered the wrong password five times.\nPlease use ID/Password recovery before proceeding.",
  "장기 미접속 안내" : "Inactive Account Notice",
  "6개월이상 장기 미접속으로 휴면계정 상태입니다.\n잠금 해제를 통해 이용을 하실 수 있습니다." : "Your account has been inactive for over 6 months and is now dormant.\nYou can continue using the service after unlocking your account.",
  "회원님의 계정이 6개월 이상 장기 미접속으로 비활성화되었습니다.": "Your account has been deactivated due to inactivity for over 6 months.",
  "아래 본인 인증을 완료하시면, 즉시 서비스를 다시 이용하실 수 있습니다.": "You can regain access immediately after completing the verification process below.",
  "휴대전화 인증": "Phone Number Verification",
  "이메일 인증": "Email Verification",
  "이메일 본인 인증": "Email Identity Verification",
  "휴대전화 본인 인증" : "Phone Number Identity Verification",
  "휴면계정회원을 확인할 수 없습니다.\n입력정보를 확인해 주세요.": "We could not confirm your dormant account.\nPlease check the information you entered.",
  "회원체크 중 오류가 발생했습니다.": "An error occurred while checking the account.",
  "인증코드를 입력해 주세요.": "Please enter the verification code.",
  "회원가입 시 등록한 아이디(이메일 주소)를 입력하여 본인인증을 진행해 주세요.": "Please enter the email address you used at sign-up to proceed with identity verification.",
  "휴면해지": "Reactivate Account",
  "휴면 상태가 해제되었습니다.": "Your account has been successfully reactivated.",
  "로그인 후 서비스를 이용해 주세요.": "Please return to the login page to continue using the service.",
  "개인정보 보호를 위해 [마이페이지]에서 비밀번호를 변경해 주세요.": "For security purposes, please change your password in My Page after logging in.",
  "본인인증을 실패했습니다.": "Identity verification failed.",
  "입력하신 이메일로 OTP가 발송되었습니다." : "Verification code sent to your email.",
  "인증이 완료되었습니다." : "Verification completed.",

  // ---------- MAIN ----------
  "실감형 교육의 Core Hub": "The Core Hub of Immersive Education",
  "기관과 기술, 학습자와 데이터를 유기적으로": "Connecting organizations, technology, learners, and data",
  "연결하는 공유 플랫폼," : "A shared platform",
  "이제 실감형 교육의 중심 허브가 됩니다.": "that becomes the center of immersive education.",
  "OpenVLab은?": "About OpenVLab",
  "한국방송통신대학교가 교육부의 'AID 30+ 프로젝트' 일환으로": "An open public learning platform established by Korea National Open",
  "구축하는 개방형 공공 학습 플랫폼입니다.": "University as part of the Ministry of Education’s AID 30+ project.",
  "대학, 기업, 개발자들이 만든 XR(VR/AR) 학습 콘텐츠를 공유하고, 고등·평생·직업교육기관 학습자에게 무료로 제공해 교육 접근성을 높입니다." : "Designed as a next-generation public learning gateway, this platform curates advanced XR (VR/AR) learning content created by leading universities, industry partners, and professional developers.",
  "또한, 고비용·고위험 실험을 대체하는 가상 실험실습실 서비스를 제공하여 교육 예산의 효율성을 향상시키는 것을 목표로 합니다.": "By providing these resources at no cost to learners across higher education and Continuing Vocational Education and Training (CVET), it expands equitable access to high-value immersive learning.",
  "공유플랫폼 API": "Shared Platform API",
  "OpenVLab은 대학, 평생교육기관, 직업교육기관 등 다양한 기관이 보유한 학습 콘텐츠를 공유하는 방식으로 운영됩니다. 콘텐츠를 제공하고자 하는 기관은 OpenVLab에서 제공하는 API를 통해 자체 LMS와 연동하여 콘텐츠를 제공하게 됩니다.": "OpenVLab operates by sharing learning content held by various organizations. Providers can offer their content by integrating their LMS with OpenVLab through the provided API.",
  "자세히 보기" : "Learn More",
  "OpenVLab의" : "Browse the latest courses on",
  "최신강좌를 확인해 보세요." : "OpenVLab.",
  "더 많은 강좌 보기" : "View More Courses",
  "위험하거나 구현이 어려운 실습,": "Experience high-risk or technically demanding training",
  "이제 가상현실에서": "within a refined,",
  "직접 경험해 주세요.": "immersive VR environment.",
  "더 많은 콘텐츠 보기": "View More Content",
  "눈으로 보고, 몸으로 배우는" : "A dynamic XR learning space where,",
  "XR 학습의 현장" : "visual understanding meets hands-on mastery.",
  "체험관 소개" : "Overview",
  "한국방송통신대학교의 가상실험실습체험관은 디지털 기술에 익숙하지 않은 분들도 부담 없이 참여할 수 있도록, 실용적이고 기본적인 커리큘럼을 가진 콘텐츠들로 구성되어 있습니다." : "The Virtual Laboratory Experience Center at Korea National Open University offers an accessible, well-designed set of foundational XR modules, enabling even digital newcomers to engage comfortably in immersive learning.",
  "XR콘텐츠 체험신청" : "Apply for Experience",
  "OpenVLab은 대학, 평생교육기관, 직업교육기관 등 다양한 기관이 보유한 학습 콘텐츠를 공유하는 방식으로 운영됩니다." : "OpenVLab allows universities, continuing vocational education, and training center to share their learning content.",
  "콘텐츠를 제공하고자 하는 기관은 OpenVLab에서 제공하는 API를 통해 자체 LMS와 연동하여 콘텐츠를 제공하게 됩니다." : "Providers can easily integrate their LMS with OpenVLab through the API to deliver content.",

    // ---------- OVERVIEW ----------
  "실감형 교육의" : "The Core Hub for",
  "중심 허브" : "Immersive Education",
  "OpenVLab은 한국방송통신대학교가 교육부의 'AID 30+ 프로젝트'" : "OpenVLab is an open public learning platform established",
  "의 일환으로 구축하는 개방형 공공 학습 플랫폼입니다." : "by Korea National Open University under the Ministry of Education’s “AID 30+ Project.”",
  "기관과 기술, 학습자, 데이터를 유기적으로 연결하여 실감형 교육의" : "The platform aims to serve as a central hub for immersive education by seamlessly connecting",
  "중심 허브가 되는 것을 목표로 합니다." : "organizations, technologies, learners, and data.",
  "대학, 기업, 개발자들이 보유한" : "It supports the sharing and collaboration of XR (VR/AR)",
  "XR(VR/AR) 학습 콘텐츠를 공유하고," : "learning content held by higher education and Continuing",
  "협업할 수 있도록 돕습니다." : "Vocational Education and Training (CVET), and enterprises.",
  "대학, 기업, 개발자들이" : "It supports the sharing and collaboration",
  "보유한 XR(VR/AR)" : "of XR (VR/AR) learning content held by",
  "학습 콘텐츠를 공유하고," : "higher education and Continuing",
  "학생 및 일반인" : "Students and the Public",
  "고등, 평생, 직업교육기관의 학생들은 물론, 일반인들도 다양하고 풍부한 교육 콘텐츠에 무료로 접근할 수 있습니다. 고위험·고비용·특수환경 실험실습 및 실감형 기술이 적용될 수 있는 다양한 분야의 콘텐츠를 통해 효과적인 학습을 경험하며 지식 습득과 역량 강화에 도움을 받을 수 있습니다." : "Students of higher education, Continuing Vocational Education and Training (CVET), along with the general public, are provided free access to diverse and comprehensive educational content. By engaging with content across multiple fields that incorporates immersive technologies and supports high-risk, high-cost specialized laboratory experiments and hands-on training, learners can achieve effective learning outcomes and strengthen their knowledge and capabilities.",
  "교육기관" : "Academic Institution",
  "각 교육기관은 보유한 XR 콘텐츠를 플랫폼에 탑재하여 기관간에 서로 공유하고, 기관의 LMS와 연동하여 교육에 활용할 수 있습니다. 이 를 통해 각 기관은 콘텐츠 제작 부담을 줄이고 콘텐츠를 활용하여 교육의 효과를 높일 수 있습니다." : "Educational institutions may upload their XR content to the platform, enabling inter-institutional sharing and integration with their respective LMSs for instructional use. This allows institutions to reduce the cost and effort of content development while improving learning outcomes through effective content utilization.",
  "개발사" : "Developer",
  "보유한 콘텐츠를 플랫폼에 공유함으로써 사회공헌 활동을 펼치거나, 산학 협력 기회를 확대할 수 있습니다. 또한, 직무 교육이나 직원 훈련에 필요한 고비용, 고위험의 가상 콘텐츠를 활용하여 직업 교육의 효율성을 높일 수 있습니다." : "By sharing their content on the platform, organizations can engage in social contribution activities and expand opportunities for industry–academia collaboration. In addition, by utilizing high-cost, high-risk virtual content required for job training and employee education, they can enhance the effectiveness of vocational education.",
  "연결이 만드는 새로운 서비스" : "New Services Powered by Connectivity",
  "표준 API로 서비스와 데이터를 간편하게 이용해 주세요." : "Easy access to services and data with standard APIs.",
  "실감형 학습콘텐츠" : "Immersive Learning",
  "공유 플랫폼" : "Content Platform",
  "고비용, 고위험, 특수환경의 물리적 실험·실습 환경을 대체하는 가상 실험·실습·체험·훈련 콘텐츠를 제공합니다." : "It offers virtual experiment, practice, experience, and training content that serves as an alternative to high-cost, high-risk physical laboratory and hands-on environments.",
  "HMD(Head Mounted Display), Mobile, PC 등" : "Supports a wide range of devices, including",
  "다양한 기기 지원이 가능합니다." : "HMD(head-mounted displays), mobile devices, and PCs.",
  "눈으로 보고, 몸으로 배우는\nXR 학습의 현장" : "An XR Learning Experience\nThrough Action",
  "학습 데이터를 한눈에 조망하는\n학습의 본부" : "A Central Learning Hub for\nManaging Learning Data",
  "언제 어디서나 연결되는\n학습의 일상" : "Learning Connected Anytime,\nAnywhere",
  "대학교 등 고등교육기관에서 필요한" : "Universities and other higher education",
  "다양한 분야의 콘텐츠를" : "institutions, are able to share and leverage",
  "공유 및 활용이 가능합니다." : "diverse content across multiple disciplines.",
  "대학교 등 고등교육기관에서" : "Universities and other",
  "필요한 다양한 분야의" : "higher education institutions,",
  "콘텐츠를 공유 및 활용이" : "are able to share and leverage diverse content",
  "가능합니다." : "across multiple disciplines.",
  "생활/재난 안전" : "Life & Disaster Safety",
  "대피 구조 순서 훈련" : "Evacuation and Rescue Training",
  "화학 실험 실습" : "Chemistry Lab Exercises",
  "위험한 시약 없이 진행" : "Conducted Without Hazardous Chemicals",
  "산업안전" : "Industrial Safety",
  "사고 재현과 대처 훈련" : "Incident Simulation and Response Training",
  "물리 치료" : "Rehabilitation Therapy",
  "동작을 따라하며 재활 체험" : "Rehabilitation Experience by Following Movements",
  "반도체 공정 견학" : "Semiconductor Process Observation",
  "클린룸 공정 가상 투어" : "Virtual Cleanroom Process Tour",
  "현실보다 생생한" : "The Beginning of",
  "배움의 시작" : "Hyper-Realistic Learning",
  "가상실험실습학습콘텐츠 공유플랫폼 구축 사업 설명회 및 학습콘텐츠 제작표준(안) 마련을 위한 공청회" : "Public hearing for the Virtual Lab Learning Content Sharing Platform and Draft Content Production Guidelines.",
  "일시: 2025년 9월 18일(목) 10:30~12:30" : "Date & Time: September 18, 2025 (Thu), 10:30~12:30",
  "장소: 서울 코엑스 A홀, Edtech ARENA 2(S07)" : "Location: COEX Hall A, Seoul — Edtech ARENA 2 (S07)",
  "주최: 한국방송통신대학교 OpenVLab 구축사업단" : "Host: Korea National Open University OpenVLab Project Team",
  "방송대 OpenVLab구축 사업단은 2025년 9월 강남구 코엑스에서 열린 \"2025 에듀테크 코리아페어\"에 참가하여 가상실험실습 학습 콘텐츠 공유 플랫폼 구축 사업에 대한 홍보 및 학습콘텐츠 제작표준(안) 마련을 위한 공청회를 진행했습니다." : "In September 2025, the Korea National Open University OpenVLab Project Team attended the \"2025 EduTech Korea Fair\" at COEX, Gangnam-gu, to promote the virtual lab learning content sharing platform project and conduct a public hearing on draft standards for learning content production.",
  "별도 공간에 마련된 홍보부스에서는 관람객들이 가상실험실습을 체험해볼 수 있도록 하고, 공청회를 통하여 효율적이고 활용도 높은 가상실험실 습 학습 콘텐츠 제작 표준을 제작 하기 위한 교육 및 산업계 관계자들의 의견을 수렴했습니다." : "Visitors at the dedicated booth could experience virtual lab exercises, while the public hearing collected input from education and industry professionals to develop effective and practical standards for virtual lab content creation.",
  "방송대 이병래 부총장(사업단장)은 \"참석자들의 다양한 제언이 가상실험실습 학습콘텐츠 제작 및 공유 플랫폼 활성화의 기반을 다지는 첫걸음 이 되기를 기대한다\" 라고 인사말을 전했습니다." : "Vice President Lee Byung-rae of Korea National Open University, who also heads the project team, remarked, “We look forward to the participants’ various suggestions serving as the first step in establishing and revitalizing the virtual lab learning content sharing platform.”",
  "출처:" : "Source:",

  // ---------- COURSES & CONTENT ----------
  "수강신청 기간": "Enrollment Period",
  "강좌학습 기간": "Learning Period",
  "저작권" : "Copyright",
  "강좌 정보를 찾을 수 없습니다.": "Course information could not be found.",
  "상세정보": "Details",
  "지원기기": "Supported Devices",
  "지원 기기": "Supported Devices",
  "이용안내": "User Guide",
  "저작권 안내": "Copyright",
  "저작권 유형": "Copyright Type",

  // ---------- SURPPORT ----------
  "강좌관련" : "Course",
  "API관련" : "API",
  "회원" : "Member",
  "장비" : "Device",
  "기타" : "ETC",
  "이메일" : "Email",
  "대분류를 선택해 주세요": "Select main category",
  "소분류를 선택해 주세요": "Select detail category",
  "분류를 선택해 주세요": "Select category",
  "내용": "Description",
  "제목을 입력해 주세요": "Enter title",
  "내용을 입력해 주세요": "Enter message",
  "강좌를 선택해 주세요": "Select course",
  "첨부파일은 pdf, jpg, jpeg, png, hwp, hwpx, ppt, pptx, doc, docx 형식만 가능합니다." : "Attachments must be in one of the following formats: PDF, JPG, JPEG, HWP, HWPX, PPT, PPTX, DOC, or DOCX.",
  "답변은 입력하신 이메일로 보내드립니다. 혹시 메일이 도착하지 않으면 스팸함을 확인해 주세요." : "A response will be sent to your email. Please check your spam folder if you do not receive it.",
  "선택하신 카테고리에는 등록된 FAQ가 없습니다." : "No FAQs are available in the selected category.",
  "사이트문의": "Website Inquiry",
  "일반문의": "General Inquiry",
  "사업제안": "Business Proposal",
  "OpenAPI문의": "Open API Inquiry",
  "체험관문의": "Experience Center Inquiry",
  "학습문의": "Learning Inquiry",
  "콘텐츠문의": "Content Inquiry",
  "강의 내용과 관련 없는 문의에는 답변을 드리지 않을 수 있는 점 참고해 주세요." : "Inquiries not related to the course content may not receive a response.",
};

export default table;
